import {inject, Injectable} from '@angular/core';
import {IconStatus} from "../../../../models/icon-status-config";
import {defaultDocumentsFilesStatus, isDocumentBtnKey, isDocumentRowKey} from "../configs/documents-modal-row-config";
import {Options} from "../types/document-modal.types";
import {DocumentStatusType} from "../types/document-status.types";
import {FilesStatus, GetFilesStatusParams} from "../../../../types/files-status.types";
import {FilesService} from "../../../../services/files.service";
import {documentResourceType} from "../configs/documents-model-config";

@Injectable({
  providedIn: 'root'
})
export class DocumentStatusService {
  private filesService: FilesService = inject(FilesService);

  public getBtnIconStatus({ key, documentsData }: DocumentStatusType): IconStatus {
    if (!isDocumentBtnKey(key)) { return 'ERROR'; }

    const section = documentsData?.[key];
    return section?.documentStatus ?? 'ERROR';
  }

  public getCurrentStatusValue({ key, documentsData }: DocumentStatusType): string | null {
    if (!isDocumentRowKey(key)) { return null; }

    const section = documentsData?.[key];
    return section?.status?.currentValue || null;
  }

  public getStatusOptions({ key, documentsData }: DocumentStatusType): Array<Options> {
    if (!isDocumentRowKey(key)) { return []; }

    const section = documentsData?.[key];
    return section?.status?.options || [];
  }

  public async getFilesStatus(id: number): Promise<FilesStatus> {
    const getFilesStatusParams: GetFilesStatusParams = {
      id: id,
      path: documentResourceType.path
    };

    return await this.filesService.fetchFilesStatus(getFilesStatusParams).catch(() => defaultDocumentsFilesStatus);
  }
}
